import { useMemo } from 'react';
import { match } from 'ts-pattern';
import { BASE_GOALS_FILTER_OPTIONS, GoalsFilter } from '../constants';
import { useGoalsContext } from '../contexts/GoalsContext';

export const useFilterOptions = () => {
  const {
    creatorAndModifiers: { goalsCreators, goalsModifiers },
  } = useGoalsContext();

  const filterOptions = useMemo(() => {
    const creatorOptions = goalsCreators.map(({ id, fullName }) => ({
      id,
      label: fullName as string,
    }));

    const modifierOptions = goalsModifiers.map(({ id, fullName }) => ({
      id,
      label: fullName as string,
    }));

    return BASE_GOALS_FILTER_OPTIONS.map((option) => ({
      ...option,
      options: match(option.id)
        .with(GoalsFilter.CREATOR, () => creatorOptions)
        .with(GoalsFilter.MODIFIER, () => modifierOptions)
        .otherwise(() => option.options),
    }));
  }, [goalsCreators, goalsModifiers]);

  return filterOptions;
};
